var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationItem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C4.7 10 4.5 9.90001 4.3 9.70001L0.3 5.70001C-0.1 5.30001 -0.1 4.70001 0.3 4.30001C0.7 3.90001 1.3 3.90001 1.7 4.30001L4.9 7.50001L10.2 0.400007C10.5 7.09295e-06 11.2 -0.099993 11.6 0.200007C12 0.500007 12.1 1.20001 11.8 1.60001L5.8 9.60001C5.6 9.80001 5.4 10 5 10Z",
    fill: "#393B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationItem);
export default __webpack_public_path__ + "static/media/notification-item.f0bfa1e457f017174b61455d0e0d1248.svg";
export { ForwardRef as ReactComponent };